import {
    splitTestActions,
} from 'wanderu-ducks-split-test';
import {
    actionDuckUtils,
} from 'wanderu-ducks-utils';
import Logger from 'wanderu-logger';

import { actions as countryGuideActions } from '../../appstate/placeGuide';
import { getCountryGuideContent } from '../../services/seoService';
import sliceNamespace from '../../types';

const logger = Logger.getLogger('fetchCountryGuide');

const namespace = 'ACTIONS/FETCH_COUNTRY_DATA';
const {
    actions,
    reducer,
    selectors,
} = actionDuckUtils.buildBaseDuck(namespace, sliceNamespace);

function fetchCountryGuide(localeAwareCountryGuideId, country, transMode, locale) {
    return async function(dispatch) {
        let error = null;

        dispatch(actions.startWork(localeAwareCountryGuideId));

        try {
            const { result } = await getCountryGuideContent({
                locale,
                country,
                transMode,
            });
            const {
                ab_testing_info: abTestingInfo,
            } = result;

            if (abTestingInfo) {
                abTestingInfo.forEach((abTest) => {
                    dispatch(splitTestActions.addTestParams([{
                        ...abTest,
                        name: abTest.experiment_name,
                        apply_test: true,
                        do_not_track: true,
                    }]));
                });
            }

            dispatch(countryGuideActions.setPlaceGuideContent(result, localeAwareCountryGuideId));
            return result;
        } catch (ex) {
            logger.error('fetch', ex, {
                country,
                locale,
                localeAwareCountryGuideId,
                transMode,
            });

            error = {
                code: ex.code,
                message: 'set country guide failed',
                name: ex.code,
                status: ex.responseBody.error.status,
            };
        } finally {
            dispatch(actions.endWork(localeAwareCountryGuideId, undefined, error));
        }

        return undefined;
    };
}

const fetchCountryGuideSelectors = {
    ...selectors,
    selectNotFound(appState, id) {
        const opStatus = selectors.idSelector(appState, id);

        return opStatus
            && opStatus.error
            && opStatus.error.code === 'INVALID_COUNTRY_GUIDE';
    },
};

const fetchCountryGuideAction = {
    fetchCountryGuide,
    ...fetchCountryGuideSelectors,
};

export {
    fetchCountryGuideAction,
    namespace,
};

export default {
    [namespace]: reducer,
};
